import { GetDocumentoComercialImportadoByIdDtoProps } from "api/DTOs/GetDocumentoComercialImportadoByIdDto"
import { GetDocumentoComercialImportadoById } from "api/DocumentoImportado.service"
import { getFicheroIdFile } from "api/Fichero.service"
import NativePDFViewer from "common/components/NativePDF/NativePDF"
import { userSelector } from "features/User/redux/slices/userSlice"
import { useSelector } from "hooks/useSelector"
import { ProgressSpinner } from "primereact/progressspinner"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"
import { globalSelector } from "routes/globalSlice"
import MainForm from "../../forms/MainForm/MainForm"
import useImportarFacturaOcr from "../../hooks/useImportarFacturaOcr"

const RevisionFacturas = () => {
  const { t } = useTranslation()
  const [facturaImportada, setFacturaImportada] =
    useState<GetDocumentoComercialImportadoByIdDtoProps>({})
  const [isLoading, setIsLoading] = useState(false)
  const { id } = useSelector(userSelector)
  const [ficheroPdf, setFicheroPdf] = useState<Blob>()
  const { tiposImpuestosArticulos } = useSelector(globalSelector)
  const { handlePostFactura, importandoFactura } = useImportarFacturaOcr()
  const params = useParams()

  useEffect(() => {
    if (params?.id) {
      setIsLoading(true)
      GetDocumentoComercialImportadoById(params.id)
        .then((res) => {
          setFacturaImportada(res)
          res?.ficheroId &&
            getFicheroIdFile(res.ficheroId).then((res) => setFicheroPdf(res))
        })
        .finally(() => setIsLoading(false))
    }
  }, [params?.id])

  return (
    <div className='px-4 pt-4 overflow-auto col h-100 remove-scroll'>
      {isLoading ? (
        <ProgressSpinner />
      ) : (
        <div className='row h-100'>
          <div className='col-lg-5 col-md-12'>
            <MainForm
              factura={facturaImportada}
              // @ts-expect-error TS(2322): Type '{ factura: $TSFixMe; tiposImpuestosArticulos: $TSFixMe...
              tiposImpuestosArticulos={tiposImpuestosArticulos}
              postFacturaOCR={handlePostFactura}
              loading={importandoFactura}
              id={id}
              t={t}
            />
          </div>

          <div className='col-lg-7 col-md-12 pdf-factura-container'>
            <NativePDFViewer
              pdf={ficheroPdf}
              type='stream'
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default RevisionFacturas
